import { Case } from '../case';
import { CaseCreditor } from '../creditors/case-creditor';
import { Person } from '../people/person';

export class CaseAsset {
  public id?: string;
  public case?: Case;
  public owner?: string;
  public person?: Person;
  public value: number = 0;
  public note?: string;
  public createdAt?: string;
  public excluded: boolean;
  public caseCreditor: CaseCreditor;
  public receivedValue?: number = 0;
}
